import React from "react";
import { Button, Text, VStack } from "@chakra-ui/react";
import { BsInbox } from "react-icons/bs";
import RiskReviewPanel from "./RiskReviewPanel";

const RiskReviewEmptyState = ({ title = "No Risk Reviews found", message, actionLabel, onAction }) => {
  return (
    <RiskReviewPanel p={8}>
      <VStack spacing={3} color="gray.500">
        <BsInbox size={28} />
        <Text fontWeight="semibold">{title}</Text>
        {message ? (
          <Text color="gray.500" textAlign="center">
            {message}
          </Text>
        ) : null}
        {actionLabel ? (
          <Button colorScheme="blue" size="sm" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </VStack>
    </RiskReviewPanel>
  );
};

export default RiskReviewEmptyState;
